import { Pipe, PipeTransform } from '@angular/core';
import { OBTRailJourneyOption } from '@sabstravtech/obtservices/base';

import { classSelectors } from '../../modal/cheapest-fare-finder-modal/cheapest-fare-finder-modal..component';

@Pipe({
  name: 'cheapestFareFinderOutbounds',
  standalone: false
})
export class CheapestFareFinderOutboundsPipe implements PipeTransform {
  transform(
    journeys: OBTRailJourneyOption[],
    resultMatrix: any,
    classSelector: classSelectors
  ): any {
    if (journeys && resultMatrix && classSelector) {
      return journeys.filter(
        (journey) =>
          resultMatrix[journey.journeyHash] &&
          this.checkOutbounds(resultMatrix, journey.journeyHash, classSelector)
      );
    } else {
      return [];
    }
  }

  checkOutbounds(resultMatrix: any, journeyHash: string, classSelector: classSelectors) {
    const hasOneAvailableValue = !!Object.keys(resultMatrix[journeyHash]).find((key) => {
      if (
        resultMatrix[journeyHash][key][classSelector]?.out &&
        resultMatrix[journeyHash][key][classSelector]?.in
      ) {
        return true;
      } else {
        return false;
      }
    });
    return hasOneAvailableValue;
  }
}
